import { StatusCode } from 'api/grpc/resources';
import { nanoid } from 'nanoid';

export const createInputStatus = (code: number = StatusCode.SUCCESS, description: string = ''): CF.API.Status => ({
  code,
  description,
});

export const createInput = (
  data: CF.API.Inputs.AnyInputData,
  id: string = nanoid(),
  createdAt: string = new Date().toISOString(),
  modifiedAt: string = new Date().toISOString(),
  status: CF.API.Status = createInputStatus(),
): CF.API.Inputs.Input => ({
  id,
  created_at: createdAt,
  modified_at: modifiedAt,
  status,
  data,
});

export const fileTypeInputShapeMap = {
  image: (base64: string): CF.API.Inputs.Input =>
    createInput({
      image: {
        base64,
      },
    }),
  video: (base64: string): CF.API.Inputs.Input =>
    createInput({
      video: {
        base64,
      },
    }),
  text: (textContent: string): CF.API.Inputs.Input =>
    createInput({
      text: {
        raw: textContent,
      },
    }),
};

export const urlTypeInputShapeMap = {
  image: (url: string, allow_duplicate_url: boolean): CF.API.Inputs.Input =>
    createInput({
      image: {
        url,
        allow_duplicate_url,
      },
    }),
  video: (url: string, allow_duplicate_url: boolean): CF.API.Inputs.Input =>
    createInput({
      video: {
        url,
        allow_duplicate_url,
      },
    }),
};
